import * as React from 'react';
import { useState, useEffect } from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';

import { checkboxStyle } from '../StyledComponent'
import { CustomDropdownIcon } from '../CustomDropDownIcon';

export const DoctorStatusFilter = ({ filterTitle, activeFilter, setActiveFilter }) => {
    const [selcetedFilter, setSelectedFilter] = useState(activeFilter);
    const [open, setOpen] = useState(false);

    const handleFilterSelection = () => {
        setActiveFilter(
            selcetedFilter
        );
        setOpen(false);
        setSelectedFilter();
    }

    const clearFilter = () => {
        setSelectedFilter();
        setActiveFilter()
    }

    const handleChange = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const {
            target: { value },
        } = event;
        setSelectedFilter(
            typeof value === 'string' ? parseInt(value, 10) : value,
        );
    };

    return (
        <div className="flex flex-row gap-4 px-8 pb-4 w-[220px]" >
            <FormControl sx={{ padding: 0, display: 'flex', minWidth: '12.5rem' }} className='border border-solid border-gray-100 rounded-xl'>
                <p htmlFor="grouped-native-select" className="text-[#252D38] text-sm font-normal leading-6 px-2 space-y-1 ">{filterTitle}</p>
                <Select
                    value={selcetedFilter}
                    displayEmpty
                    open={open}
                    onClose={() => { setOpen(false); }}
                    onOpen={() => { setOpen(true); setSelectedFilter(activeFilter); }}
                    onChange={handleChange}
                    input={<OutlinedInput sx={{ padding: 0, margin: 0 }}> </OutlinedInput>}
                    IconComponent={CustomDropdownIcon}
                    renderValue={
                        () => {
                            if (!activeFilter && activeFilter != 0) {
                                return (
                                    <div className="flex text-base" style={{ alignItems: 'center' }}>
                                        <img
                                            style={{ width: 34, height: 25 }}
                                            src="https://views.medibuddy.in/providerUi/assets/filter.svg"
                                            alt="remove filter"
                                        />
                                        <div class="overflow-hidden text-gray-700 truncate text-base font-normal leading-6 ">
                                            Set Filter
                                        </div>
                                    </div>
                                )
                            }
                            return (
                                <>
                                    <div className="flex flex-row align-center relative gap-2">
                                        <img
                                            style={{ width: 34, marginTop: 0, height: 24 }}
                                            src="https://views.medibuddy.in/providerUi/assets/filter-remove.svg"
                                            alt="remove filter"
                                            className='relative flex justify-center items-center '
                                        />
                                        <div class="overflow-hidden text-gray-700 truncate  text-base font-normal leading-6  ">
                                            {activeFilter == '1' ? `Active` : `Inactive`}
                                        </div>
                                    </div>
                                </>
                            )
                        }
                    }
                    sx={checkboxStyle}
                >
                    <div className="flex flex-row  px-4 w-full">
                        <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label "
                            name="radio-buttons-group"
                            className='flex flex-row  px-2  w-full'
                            value={selcetedFilter}
                            onChange={handleChange}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <FormControlLabel value="1" className='gap-2' control={<Radio />} label="Active" />
                            <FormControlLabel value="0" className='gap-2' control={<Radio />} label="Inactive" />
                        </RadioGroup>
                    </div>
                    <div className="block flex w-full justify-around sticky bottom-0 bg-white py-2" style={{ borderTop: '1px solid #E5E5E5', zIndex: 100 }}>
                        <button className={`w-1/2 rounded-lg  ml-2  text-mb-red-500`} onClick={clearFilter}>Clear All</button>
                        <button className={` bg-blue-600 border border-solid border-gray-100 w-1/2 rounded-lg  mx-2 text-white`} onClick={handleFilterSelection}>Apply</button>
                    </div>
                </Select >
            </FormControl>
        </div>
    );
}